import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { appendToAssistantDetail } from '../../store/app/assistantSlice';
import { TRANSCRIBER_CONFIG } from '../../utils/assistants/transcriber_config';

function TranscriberComponent() {
  const dispatch = useDispatch();
  const assistantDetails = useSelector((state) => state?.assistants?.activeDetail?.details || {});


  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [enableBackgroundNoise, setEnableBackgroundNoise] = useState(false);

  const transcribers = Object.keys(TRANSCRIBER_CONFIG);
  const models = selectedProvider ? Object.values(TRANSCRIBER_CONFIG[selectedProvider]?.models || {}) : [];
  const languages = selectedProvider ? Object.values(TRANSCRIBER_CONFIG[selectedProvider]?.languages || {}) : [];

  useEffect(() => {
    if (assistantDetails?.transcriber) {
      setSelectedProvider(assistantDetails.transcriber.provider || '');
      setSelectedModel(assistantDetails.transcriber.model || '');
      setSelectedLanguage(assistantDetails.transcriber.language || '');
      setEnableBackgroundNoise(!!assistantDetails.backgroundDenoisingEnabled);
    }
  }, [assistantDetails]);

  useEffect(() => {
    if (!selectedProvider) return;

    dispatch(
      appendToAssistantDetail({
        transcriber: {
          provider: selectedProvider,
          model: selectedModel,
          language: selectedLanguage,
        },
        backgroundDenoisingEnabled: enableBackgroundNoise
      })
    );
  }, [selectedProvider, selectedModel, selectedLanguage, enableBackgroundNoise, dispatch]);

  return (
    <div className="card transcriber-card">
      <div className="mb-10">Choose Transcriber</div>
      <div className="transcriber-flex-gap">
        {/* Provider */}
        <div style={{ position: 'relative', flex: '1' }}>
          <select
            className="agent-form-input flex-1"
            value={selectedProvider}
            onChange={(e) => {
              setSelectedProvider(e.target.value);
              setSelectedModel('');
              setSelectedLanguage('');
            }}
          >
            <option disabled value="">
              Select Transcriber
            </option>
            {transcribers.map((provider) => (
              <option key={provider} value={provider}>
                {provider}
              </option>
            ))}
          </select>
          <ChevronDown
            size={20}
            style={{
              position: 'absolute',
              right: '12px',
              top: '40%',
              transform: 'translateY(-50%)',
              color: '#9CA3AF',
              pointerEvents: 'none',
            }}
          />
        </div>

        {/* Model */}
        <div style={{ position: 'relative', flex: '1' }}>
          <select
            className="agent-form-input flex-1"
            value={selectedModel}
            onChange={(e) => setSelectedModel(e.target.value)}
            disabled={!selectedProvider}
          >
            <option disabled value="">
              Select Model
            </option>
            {models.map((model) => (
              <option key={model} value={model}>
                {model}
              </option>
            ))}
          </select>
          <ChevronDown
            size={20}
            style={{
              position: 'absolute',
              right: '12px',
              top: '40%',
              transform: 'translateY(-50%)',
              color: '#9CA3AF',
              pointerEvents: 'none',
            }}
          />
        </div>
      </div>

      {/* Language */}
      <div className="mt-10" style={{ position: 'relative', flex: '1' }}>
        <select
          className="agent-form-input flex-1"
          value={selectedLanguage}
          onChange={(e) => setSelectedLanguage(e.target.value)}
          disabled={!selectedProvider}
        >
          <option disabled value="">
            Select Language
          </option>
          {languages.map((lang) => (
            <option key={lang} value={lang}>
              {lang}
            </option>
          ))}
        </select>
        <ChevronDown
          size={20}
          style={{
            position: 'absolute',
            right: '12px',
            top: '40%',
            transform: 'translateY(-50%)',
            color: '#9CA3AF',
            pointerEvents: 'none',
          }}
        />
      </div>

      {/* Background Noise Toggle */}
      <div className="text-x mt-20">Background Denoising Enabled</div>
      <div className="text-xs m-10 flex" style={{ justifyContent: 'space-between' }}>
        Filter background noise while the user is talking.
        <label className="toggle-label">
          <input
            type="checkbox"
            checked={enableBackgroundNoise}
            onChange={() => setEnableBackgroundNoise((prev) => !prev)}
            className="toggle-input"
          />
          <span className={`toggle-slider ${enableBackgroundNoise ? 'enabled' : ''}`}></span>
          <span className={`toggle-circle ${enableBackgroundNoise ? 'enabled' : ''}`}></span>
        </label>
      </div>
    </div>
  );
}

export default TranscriberComponent;
